/**
 * Block Video Carousel.
 */
import $ from 'jquery';
import 'slick-carousel';
import { breakpoints } from './variables';
import { forceLazyLoad } from '../global/helpers';

const carousels = document.querySelectorAll('.em-video-carousel');
if (carousels.length) {
	carousels.forEach((carousel) => {
		// Force images to load.
		forceLazyLoad(carousel);

		const sliderOne = carousel.querySelector('.em-video-carousel__one');
		const sliderTwo = carousel.querySelector('.em-video-carousel__two');

		if (sliderOne) {
			$(sliderOne).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				infinite: true,
				useTransform: true,
				asNavFor: '.em-video-carousel__two',
			});
		}

		if (sliderTwo) {
			$(sliderTwo).slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				centerMode: false,
				dots: false,
				infinite: true,
				arrows: false,
				lazyLoad: false,
				focusOnSelect: true,
				asNavFor: '.em-video-carousel__one',
				responsive: [
					{
						breakpoint: breakpoints.md.max,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: breakpoints.xs.max,
						settings: {
							slidesToShow: 2,
						},
					},
				],
			});
		}
	});
}
